<template>
  <recording-position-tracker
    class="event-capture"
    :updateInterval="updateInterval"
    @elapsed="sendProgress"
  ></recording-position-tracker>
</template>

<script>

import RecordingPositionTracker from "@/components/recording/recording-position-tracker";

const timeUpdateEvent = 'timeUpdateEvent';
// const seekEvent = 'seekEvent'; // todo
const completeEvent = 'completeEvent';
const pauseEvent = 'pauseEvent';
const readyEvent = 'readyEvent';

export default {
  name: 'EventCapture',

  components: {RecordingPositionTracker},

  data() {
    return {
      updateInterval: 0
    };
  },

  computed: {
    duration() {
      return this.$store.state.recording && this.$store.state.recording.duration;
    },

    playState() {
      return this.$store.state.recording && this.$store.state.recording.playState;
    },

    contentFile() {
      return this.$store.state.recording && this.$store.state.recording.contentFile;
    }
  },

  watch: {
    contentFile(newValue) {
      if (newValue && newValue !== this.prevContentFile) {
        this.$store.dispatch('g2sRecording/sendEvent', {eventName: readyEvent});
        this.prevContentFile = newValue;
      }
    },

    playState(newValue) {
      switch (newValue) {
        case 'play':
          if(!this.firstPlay) {
            this.$telemetryTrack('Embedded video playback started');
            this.firstPlay = true;
            this.sendProgress({elapsed: this.$store.state.recording.position})
          }
          break;

        case 'pause':
          this.$store.dispatch('g2sRecording/sendEvent', {eventName: pauseEvent, eventBody: {paused: true}});
          break;

        case 'ended':
          this.sendProgress({elapsed: this.duration})
          this.$store.dispatch('g2sRecording/sendEvent', {eventName: completeEvent});
          break;
      }
    },

    duration(newValue) {
      if (newValue) {
        this.updateInterval = newValue / 20; // every 5%
        this.logger.log('duration event', {newValue, updateInterval: this.updateInterval});
      }
    }
  },

  methods: {
    sendProgress(event) {
      const elapsed = event.elapsed;
      let progress;

      if (elapsed === 0) {
        progress = 0; // update at 0
      } else if (elapsed === this.duration) {
        progress = 100; // update at end
      } else {
        const rounded = elapsed ? elapsed - (elapsed % this.updateInterval) : 0;
        progress = Math.floor((rounded / this.duration) * 100);
      }
      this.logger.log('sendEvent', {progress, elapsed});
      this.$store.dispatch('g2sRecording/sendEvent', {eventName: timeUpdateEvent, eventBody: {progress}});
    }
  },

  created() {
    this.prevContentFile = null
    this.firstPlay = false;
  }
}

</script>

<style scoped>

</style>
